/**
 * KinesisOverlay - duong cong Ember manh + cham tron (motif logo Asklaw),
 * analogue "kinesis lines" cua Thomson Reuters. Abstract SVG - KHONG khuon mat.
 */
export function KinesisOverlay({ corner = 'tl' }: { corner?: 'tl' | 'br' }) {
  return (
    <svg
      className={`ed-kinesis ed-kinesis--${corner}`}
      width="320"
      height="220"
      viewBox="0 0 320 220"
      fill="none"
      aria-hidden="true"
    >
      <path d="M-20 200 C 80 180, 140 120, 150 20" stroke="#F38020" strokeWidth="1.5" opacity="0.7" />
      <path d="M-20 160 C 70 150, 120 100, 128 10" stroke="#F38020" strokeWidth="1" opacity="0.45" />
      <path d="M-20 120 C 60 115, 100 80, 105 0" stroke="#FAAD3F" strokeWidth="1" opacity="0.3" />
      <circle cx="150" cy="20" r="4" fill="#F38020" />
      <circle cx="128" cy="10" r="2.5" fill="#F38020" opacity="0.6" />
    </svg>
  );
}
